import { safeSessionStorage } from './storage';

const DEBUG_STORAGE_KEY = '__mobile_debug_enabled__';
let isErudaLoaded = false;

/**
 * 动态加载并初始化 Eruda 移动端调试控制台
 * 支持在无 F12 的手机浏览器中查看 Console / Network / Storage / Elements
 */
export function initEruda(): Promise<void> {
  if (isErudaLoaded || (window as any).eruda) {
    if ((window as any).eruda && !(window as any).eruda._isInit) {
      (window as any).eruda.init();
      (window as any).eruda.show();
    }
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    // 使用国内常用的公共 CDN 镜像加载 eruda 脚本
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/eruda';
    script.async = true;
    script.onload = () => {
      isErudaLoaded = true;
      try {
        if ((window as any).eruda) {
          (window as any).eruda.init();
          (window as any).eruda.show();
          console.log('[MobileDebug] 移动端调试控制台已启动，可查看 Console / Network 抓包');
        }
        resolve();
      } catch (e) {
        console.error('[MobileDebug] Eruda 初始化失败:', e);
        reject(e);
      }
    };
    script.onerror = (e) => {
      console.error('[MobileDebug] 加载 eruda 脚本失败:', e);
      reject(e);
    };
    document.body.appendChild(script);
  });
}

/**
 * 初始化调试环境检测：
 * 1. 检查 URL 中是否有 ?debug=1 / ?console=1
 * 2. 检查 sessionStorage 中是否已开启调试
 */
export function setupMobileDebugListener() {
  if (typeof window === 'undefined') return;

  try {
    const urlParams = new URLSearchParams(window.location.search);
    const hasDebugParam =
      urlParams.get('debug') === '1' ||
      urlParams.get('console') === '1' ||
      urlParams.get('eruda') === '1';

    const isEnabledInStorage = safeSessionStorage.getItem(DEBUG_STORAGE_KEY) === 'true';

    if (hasDebugParam || isEnabledInStorage) {
      safeSessionStorage.setItem(DEBUG_STORAGE_KEY, 'true');
      initEruda().catch(() => {});
    }
  } catch (e) {
    // ignore
  }
}

let tapCount = 0;
let lastTapTime = 0;

/**
 * 连击唤起移动端调试控制台（5 次点击内 2 秒唤起）
 */
export function handleDebugTitleTap(): boolean {
  const now = Date.now();
  if (now - lastTapTime > 2000) {
    tapCount = 1;
  } else {
    tapCount += 1;
  }
  lastTapTime = now;

  if (tapCount >= 5) {
    tapCount = 0;
    safeSessionStorage.setItem(DEBUG_STORAGE_KEY, 'true');
    initEruda()
      .then(() => {
        alert('已激活移动端调试控制台（点击右下角齿轮/图标可查看 Console 和 Network）');
      })
      .catch((err) => {
        alert('加载调试控制台失败: ' + (err?.message || err));
      });
    return true;
  }

  return false;
}
